var render = function (_h,_vm) {var _c=_vm._c;return _c(("gl-icon-" + (_vm.props.icon)),{tag:"component",staticClass:"gl-icon"})}
var staticRenderFns = []

export { render, staticRenderFns }